{
  "satis_firma": {
    "Baslik": "Sales Companies",
    "Ad": "Company Name",
    "Durum": "Status",
    "Arama": "Search",
    "Ara": "Search",
    "Temizle": "Clear",
    "Kapat": "Close",
    "Yenile": "Refresh",
    "Data Yenile": "Refresh Data",
    "Ekle": "Add Company",
    "Filtrele": "Filter",
    "Duzenle": "Edit",
    "Sil": "Delete",
    "Kaydet": "Save",
    "Guncelle": "Update",
    "Vazgec": "Cancel",
    "Iptal": "Cancel",
    "Hepsi": "All",
    "Aktif": "Active",
    "Pasif": "Passive",
    "ARA": "Search"
  }
}
